import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { getAuth, signOut as firebaseSignOut } from 'firebase/auth';
import { logger } from '@parrot-software/observability';

import useAmplitude from 'providers/root/AmplitudeProvider/useAmplitude';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

import SignInLayout from 'components/SignInLayout';

import { ParrotLogo } from '@experimental-components/IconsComponents/ParrotLogo';

import {
  removeAuthToken,
  removeUserStoresStoreKey,
  removeUserCurrentStore,
  removeStoreDratfKey,
  removeStoreBackupKey,
  removeOrganizationUser,
  removeCookieUser,
} from 'utils/auth';
import { removeBrandSelectedLocalStorage } from 'utils/menuMaker';
import { useMenuScopeCleanup } from 'hooks/menuScope';
import { clearPersonnelSessionStorage } from '@personnel/composition';

import useStyles from './styles';

const iamLog = logger.forDomain('IAM');

function SignOut() {
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const { logEvent } = useAmplitude();
  const auth = getAuth();
  const { clearAllMenuScopeState } = useMenuScopeCleanup();
  const queryClient = useQueryClient();

  useEffect(() => {
    iamLog.info('User logged out');
    logger.clearGlobalContext();
    logEvent('@event.$login.logout');

    // Clear authentication data
    removeAuthToken();
    removeUserStoresStoreKey();
    removeUserCurrentStore();
    removeStoreDratfKey();
    removeStoreBackupKey();
    removeBrandSelectedLocalStorage();
    removeOrganizationUser();
    removeCookieUser();

    // Clear menu scope state (includes localStorage and Recoil state)
    clearAllMenuScopeState();

    // Clear personnel session storage (persisted employee filters) so the
    // next session starts from scratch
    clearPersonnelSessionStorage();

    queryClient.clear();
    firebaseSignOut(auth);
    history.push('/signin');
  }, []);

  return (
    <SignInLayout>
      <div className={classes.header}>
        <ParrotLogo className="h-16" />
      </div>

      <Box mb={2} mt={4}>
        <Typography gutterBottom variant="h6">
          {t('common:auth.signingOut')}
        </Typography>
      </Box>

      <Box mb={2} textAlign="center" width="80%">
        <CircularProgress />
      </Box>
    </SignInLayout>
  );
}

export default SignOut;
